import { Transition, Dialog } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

interface Props {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  children: ReactNode;
  large?: boolean;
  width?: string;
}

const Modal = ({ width, isOpen, onClose, title, children }: Props) => {
  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="absolute md:fixed inset-0 z-[200] "
        onClose={handleClose}
      >
        <div className="overflow-scroll text-center md:px-4 md:min-h-screen">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
          </Transition.Child>

          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full p-6 my-8 text-left align-middle transition-all transform rounded-lg ">
              {title && (
                <Dialog.Title
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900"
                >
                  {title}
                </Dialog.Title>
              )}

              <div className="flex justify-center mt-2 overflow-scroll">
                <div className={`${width ? width : 'w-full'}`}>{children}</div>
              </div>

              {/* {onClose && (
                <div className="mt-4">
                  <button
                    type="button"
                    className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-gray-800 border border-transparent rounded-md hover:bg-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-500"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              )} */}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default Modal;
